import { plugin, Mode } from 'light-component';
import { useTranslation } from '../../../i18n';
import { Thumbnail } from '../../component';
import { WidgetType } from '../types';
import { ShotEyesStarInputMode } from './input';
import { ShotEyesStarDesignMode } from './design';
import { ShotEyesStarViewMode } from './view';
import type { ReactElement } from 'react';
import type { ShotEyesStarProps } from './types';

// 问卷-评分
export function QuestionnaireStar(props: ShotEyesStarProps): ReactElement | null {
  const [t] = useTranslation();

  if (props.mode === Mode.THUMBNAIL) {
    return (<Thumbnail icon='ShotEyesStarIcon' title={t('ShotEyesStar')} toolTipContent={t('ShotEyesStar')} />);
  }

  if (props.mode === Mode.DESIGN) {
    return (<ShotEyesStarDesignMode {...props} />);
  }

  if (props.mode === Mode.VIEW) {
    return (<ShotEyesStarViewMode {...props} />);
  }

  if (props.mode === Mode.INPUT) {
    return (<ShotEyesStarInputMode {...props} />);
  }

  return null;
}

QuestionnaireStar.prototype.type = WidgetType.SHOTEYES_STAR;
plugin.register({ kind: 'widget', component: QuestionnaireStar });
